import React, { Component } from "react";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import moment from "moment";
import { ReactComponent as Calender } from "./calendar.svg";

class index extends Component {
  getArabicMonths = (date) => {
    const ar_months = {
      Jan: "يناير ",
      Feb: "فبراير",
      Mar: "مارس",
      Apr: "أبريل",
      May: "مايو",
      Jun: "يونيو",
      Jul: "يوليو",
      Aug: "أغسطس",
      Sep: "سبتمبر",
      Oct: "أكتوبر",
      Nov: "نوفمبر",
      Dec: "ديسمبر",
    };
    let newDate = date.replace(
      date.split(" ")[0],
      ar_months[date.split(" ")[0]]
    );
    newDate = newDate
      .replace("rd", "")
      .replace("th", "")
      .replace("nd", "")

      .replace("st", "");
    newDate = newDate.split(" ").reverse().join(" ");
    return newDate;
  };
  render() {
    const language = this.props.language;
    let leadTime = this.props.distributor.lead_time;
    const { distributor } = this.props;
    let dates = [];
    let datesValues = [];
    let counter = 0;
    let todayName = moment().format("dddd").toLowerCase();
    if (distributor[`deliver_on_${todayName}`]) {
      if ((moment().format("HH:mm") > distributor[`${todayName}_cutoff`])) {
        leadTime += 1;
      }
    } else {
      leadTime += 1;
    }

    while (dates.length < 14) {
      let tmpDate = moment().add(leadTime, "days").add(counter, "days");
      if (
        (tmpDate.isoWeekday() == 7 && !distributor.deliver_on_sunday) ||
        (tmpDate.isoWeekday() == 1 && !distributor.deliver_on_monday) ||
        (tmpDate.isoWeekday() == 2 && !distributor.deliver_on_tuesday) ||
        (tmpDate.isoWeekday() == 3 && !distributor.deliver_on_wednesday) ||
        (tmpDate.isoWeekday() == 4 && !distributor.deliver_on_thursday) ||
        (tmpDate.isoWeekday() == 5 && !distributor.deliver_on_friday) ||
        (tmpDate.isoWeekday() == 6 && !distributor.deliver_on_saturday)
      ) {
        counter += 1;
      } else {
        datesValues.push(tmpDate.format("YYYY-MM-DD"));
        dates.push(
          <MenuItem
            value={moment()
              .locale("en")
              .add(leadTime, "days")
              .add(counter, "days")
              .format("YYYY-MM-DD")}
            style={{ color: "black" }}
            dir={language == "english" ? "ltr" : "rtl"}
          >
            {language == "english"
              ? moment()
                  .add(leadTime, "days")
                  .add(counter, "days")

                  .format("MMM Do")
              : this.getArabicMonths(
                  moment()
                    .add(leadTime, "days")
                    .add(counter, "days")

                    .format("MMM Do")
                )}
          </MenuItem>
        );
        counter = counter + 1;
      }
    }
    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language === "english" ? "Date" : "تاريخ"}
        </p>
        <div
          className="w-100"
          style={{ backgroundColor: "white", height: 110, marginTop: 5 }}
        >
          <p
            className={"pt-3 ".concat(
              language == "english" ? "text-left pl-3" : "text-right pr-3"
            )}
            dir={language == "english" ? "ltr" : "rtl"}
          >
            <span
              style={{
                marginRight: language == "english" && 10,
                marginLeft: language == "arabic" && 10,
              }}
            >
              <Calender style={{ width: 20, height: 20, color: "#333" }} />
            </span>

            {language == "english" ? "When do you want it?" : "متى تريد طلبك؟"}
          </p>
          <div className="mx-auto" style={{ width: "92%" }}>
            <Select
              key={Math.random() * 1000}
              className="mx-auto w-100"
              ref="xx"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name={"leadTime"}
              defaultValue={datesValues[0]}
              value={this.props.date}
              dir={language == "english" ? "ltr" : "rtl"}
              onChange={this.props.handleDateChange}
            >
              {dates}
            </Select>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
  };
};
export default connect(mapStateToProps)(index);
